
export const findMatchingCarChangeDialog = (parameters, dialogTable) => {
    let friendDialogTable = [];
    for (let i=0; i<dialogTable.length; i++){
         let checkDialogObj = dialogTable[i];   
         if (checkDialogObj.carType === +parameters.carSelectType && 
                checkDialogObj.ageNbr === +parameters.carAgeType){
              friendDialogTable =  dialogTable[i].commentTable;   
              break; 
        }
    }
      
    return friendDialogTable;
   
}
export default findMatchingCarChangeDialog;

